import { getLocation } from "@/bridge/getLocation";
import { callFirebaseFunction } from "@/bridge/callFirebaseFunction";

// import type { RadarGeocodeResponse } from "radar-sdk-js/dist/types";
// import Radar from "radar-sdk-js";


// const LOCATION_RESULT_VALIDITY_DURATION = 1000 * 60 * 60;

// let ipgeolocationApi = new IPGeolocationAPI("802658f846b14e1992b670297f4a6c0a", false);

/**
 * Interface for the location request
 */
interface LocationRequest {
  latitude: number;
  longitude: number;
}

/**
 * Interface for location state response
 */
interface LocationStateResponse {
  state: {
    longName: string;
    shortName: string;
  } | null;
  formattedAddress?: string;
  message?: string;
}




export async function getLocationFrom(force = false): Promise<string | null> {
    if (!force) {
      return null;
    }

    // if (!force) {
    //   const lastLocationResult = localStorage.getItem("lastLocationResult2");
    //   if (lastLocationResult) {
    //     const parsed = JSON.parse(lastLocationResult) as RadarGeocodeResponse & {
    //       timestamp: number;
    //     };
    //     if (Date.now() - parsed.timestamp < LOCATION_RESULT_VALIDITY_DURATION) {
    //       return parsed;
    //     }
    //   }
    // }


  
    let latitude: number;
    let longitude: number;
  
    try {
      const result = await getLocation(force);
      [latitude, longitude] = result;
      window.closeAlertDialog?.("Enable Location Services");
    } catch (error) {
      if ((error as Error).message === "denied") {
        window.showAlertDialog?.(
          "Enable Location Services",
          <div>
            To continue, please enable location services. We need this to verify
            your eligibility based on your state.
            <ol style={{ textAlign: "start" }}>
              <li>
                Go to <strong>Settings</strong> &gt;{" "}
                <strong>Privacy & Security</strong> &gt;{" "}
                <strong>Location Services</strong>.
              </li>
              <li>
                Select <strong>SkillScratch</strong> and set access to{" "}
                <strong>While Using the App</strong>.
              </li>
              <li>Return to the app to continue.</li>
            </ol>
          </div>
        );
      } else if ((error as Error).message === "Location permission denied") {
        window.showAlertDialog?.(
          "Enable Location Services",
          <div>
            To continue, please enable location services. We need this to verify
            your eligibility based on your state.
            <ol style={{ textAlign: "start" }}>
              <li>
                Go to <strong>Settings</strong> &gt;{" "}
                <strong>Safari</strong> &gt;{" "}
                <strong>Location</strong>.
              </li>
              <li>
                Set access to <strong>Allow While Using</strong>.
              </li>
              <li>
                Return to Safari and reload the page to continue.
              </li>
            </ol>
          </div>
        );
      }
      return null;
    }
    
    const response = await callFirebaseFunction<LocationRequest, LocationStateResponse>(
      "getStateFromCoordinates",
      { latitude, longitude }
    );

    localStorage.setItem(
      "lastLocationResult3",
      JSON.stringify({
        timestamp: Date.now(),
        ...response,
      })
    );

    return response.state?.shortName ?? null;
  }

